import { render, staticRenderFns } from "./CompanyTree.vue?vue&type=template&id=ba4f45d4&"
import script from "./CompanyTree.vue?vue&type=script&lang=js&"
export * from "./CompanyTree.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports